export const environment = {
  production: false,
  serverUrl: '/api',
  API_KEY_PIXABAY: '21558043-ea93c1b6a6e88758325a9fcb2'
};